import { render, staticRenderFns } from "./PlatformBanners.vue?vue&type=template&id=df196388&scoped=true&"
import script from "./PlatformBanners.vue?vue&type=script&lang=js&"
export * from "./PlatformBanners.vue?vue&type=script&lang=js&"
import style0 from "./PlatformBanners.vue?vue&type=style&index=0&id=df196388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df196388",
  null
  
)

export default component.exports